<div class="migrations-container table-bottom-padding">
  <ziro-breadcrumbs>
    <ziro-breadcrumb-card-item [aboutCardId]="90"></ziro-breadcrumb-card-item>
  </ziro-breadcrumbs>

  @if (isRefreshing) {
    <div
      class="alert alert-info"
      [innerHTML]="'tkey;migrations.cisco.directory_numbers_report.loading_alert' | escapeHtml"
    ></div>
  }

  @if (isLoading || isRefreshing) {
    <ziro-loading-block></ziro-loading-block>
  }

  @if (!isRefreshing && !isLoading) {
    <div class="mb-3" data-automation="migration-summary" [innerHTML]="utilizationSummary | escapeHtml"></div>
    <div class="d-flex justify-content-end">
      <ziro-button
        [label]="'tkey;migrations.cisco.directory_numbers_report.manage_number_translation_rules.button'"
        [iconStacked]="ZiroStackedIcons[ZiroIcons.TRANSLATION_RULES]"
        [buttonStyle]="buttonStyles.OUTLINE_INFO"
        [cssClass]="'mb-2'"
        (clicked)="openNumberTranslationRulesModal()"
        [dataAutomation]="'manage-number-translation-rules-button'"
      ></ziro-button>
    </div>
    <ziro-datatable
      #datatable
      [columns]="columns"
      [rowDataSource]="data"
      [uniqueRowIdentifier]="'id'"
      [mainFilterPlaceholder]="'tkey;migrations.number_report.table.filter.placeholder' | translate"
      [dataAutomation]="tableDataAutomation"
      [stickyColumnCount]="2"
      [isColumnVisibilityFilterVisible]="true"
      [columnVisibilityFilterOptions]="groupedColumnFilterOptions"
      [columnVisibilityFilterInitialOptions]="initialGroupedColumnFilterOptions"
      [resetPageOnDataChange]="false"
      [showCustomAlert]="showCustomAlert"
      [showSelectColumn]="true"
      [setColumnWidths]="true"
      [tooltipPlacement]="'auto'"
      [showValidationMessageInTooltip]="true"
      (rowFieldChanged)="onRowFieldChange($event)"
      (rowSelected)="onRowSelected()"
      (searchResultsChanged)="onTableResultsChanged()"
      [class]="'ziro-card'"
    >
      <ziro-datatable-multi-select-filter
        #migrationStatusFilter
        [label]="'tkey;migrations.cisco.directory_numbers_report.table.migration_status.label'"
        [items]="migrationStatusOptionsWithCounts"
        [matchFn]="migrationStatusMatchFn"
        [dataAutomation]="'migration-status-filter'"
        [tableId]="tableDataAutomation"
        [showRowCount]="true"
        (isInitialized)="onFilterInitialized()"
      ></ziro-datatable-multi-select-filter>
      <ziro-datatable-multi-select-filter
        #lineTypeFilter
        [label]="'tkey;migrations.cisco.directory_numbers_report.table.usage_type.label'"
        [items]="lineTypeOptionsWithCounts"
        [matchFn]="lineTypeMatchFn"
        [dataAutomation]="'line-type-filter'"
        [tableId]="tableDataAutomation"
        [showRowCount]="true"
        (isInitialized)="onFilterInitialized()"
      ></ziro-datatable-multi-select-filter>
      <ziro-datatable-multi-select-filter
        #deviceTypeFilter
        [label]="'tkey;migrations.cisco.directory_numbers_report.table.device_usage_type.label'"
        [items]="deviceTypeOptionsWithCounts"
        [matchFn]="deviceTypeMatchFn"
        [dataAutomation]="'device-type-filter'"
        [tableId]="tableDataAutomation"
        [showRowCount]="true"
      ></ziro-datatable-multi-select-filter>
      <ziro-datatable-multi-select-filter
        #suggestedCallingProductFilter
        [label]="'tkey;migrations.cisco.directory_numbers_report.table.suggested_calling_product.label'"
        [items]="suggestedCallingProductOptionsWithCounts"
        [matchFn]="suggestedCallingProductMatchFn"
        [dataAutomation]="'suggested-calling-product-filter'"
        [tableId]="tableDataAutomation"
        [disabled]="!cdrDiffDays || cdrDiffDays < 30"
        [disabledTooltip]="'tkey;migrations.cisco.suggested_calling_products.insufficient_cdrs.tooltip'"
        (isInitialized)="onFilterInitialized()"
        [showRowCount]="true"
      ></ziro-datatable-multi-select-filter>
      <ziro-datatable-multi-select-filter
        #huntListMembershipFilter
        [label]="'tkey;migrations.cisco.directory_numbers_report.table.hunt_list_membership.label'"
        [items]="countedHuntListMembershipFilterOptions"
        [matchFn]="huntListMembershipMatchFn"
        [dataAutomation]="'hunt-list-membership-filter'"
        [tableId]="tableDataAutomation"
        (isInitialized)="onFilterInitialized()"
        [showRowCount]="true"
      ></ziro-datatable-multi-select-filter>
      <ziro-datatable-multi-select-filter
        #dnCallingSearchSpaceFilter
        [label]="'tkey;migrations.cisco.directory_numbers_report.table.filter.calling_search_space.label'"
        [items]="dnCallingSearchSpaceOptionsWithCounts"
        [matchFn]="dnCallingSearchSpaceMatchFn"
        [dataAutomation]="'dn-calling-search-space-filter'"
        [tableId]="tableDataAutomation"
        [showRowCount]="true"
      ></ziro-datatable-multi-select-filter>
      <ziro-datatable-multi-select-filter
        #routePartitionFilter
        [label]="'tkey;migrations.cisco.directory_numbers_report.table.route_partition.label'"
        [items]="routePartitionOptionsWithCounts"
        [matchFn]="routePartitionMatchFn"
        [dataAutomation]="'route-partition-filter'"
        [tableId]="tableDataAutomation"
        [showRowCount]="true"
      ></ziro-datatable-multi-select-filter>
      <ziro-datatable-multi-select-filter
        #devicePoolFilter
        [label]="'tkey;migrations.cisco.directory_numbers_report.table.associated_devices.device_pool.label'"
        [items]="devicePoolOptionsWithCounts"
        [matchFn]="devicePoolMatchFn"
        [dataAutomation]="'device-pool-filter'"
        [tableId]="tableDataAutomation"
        [showRowCount]="true"
      ></ziro-datatable-multi-select-filter>
      <ziro-datatable-multi-select-filter
        #deviceCssFilter
        [label]="'tkey;migrations.cisco.directory_numbers_report.table.device_css.label'"
        [items]="deviceCssOptionsWithCounts"
        [matchFn]="deviceCssMatchFn"
        [dataAutomation]="'device-css-filter'"
        [tableId]="tableDataAutomation"
        [showRowCount]="true"
      ></ziro-datatable-multi-select-filter>
      <div class="text-center" alert-content>
        {{ 'tkey;migrations.number_report.table.job_status.error.table_message_pre' | translate }}
        <button
          data-automation="custom-alert-button"
          class="btn btn-border btn-link strong align-baseline"
          (click)="onRefreshClick()"
          [innerHTML]="
            'tkey;migrations.cisco.directory_numbers_report.table.job_status.error.table_message_link.label'
              | escapeHtml
          "
        ></button>
      </div>
    </ziro-datatable>
  }

  <ng-template #deviceUsageTypeCell let-row="row">
    @let icon = getDeviceUsageTypeIcon(row);

    <span class="alert alert-inline alert-info">
      @if (icon && isIconStacked(icon)) {
        <ziro-stacked-icon
          [stackedIcon]="ZiroStackedIcons[icon]"
          parentClass="fa-stack text-secondary w-auto"
        ></ziro-stacked-icon>
      } @else if (icon) {
        <i class="{{ icon }} text-secondary"></i>
      }
      <span>
        {{ getDeviceUsageTypeLabel(row) }}
      </span>
    </span>
  </ng-template>
</div>
